<template>
  <div class="infographic" v-if="item">
    <div class="infographic-container">
      <div class="infographic-content">
        <h2 class="infographic-title">
          <router-link class="title-link hover:opacity-80 transition-opacity"
            :to="{ name: $t('infographicsRouteName'), params: { id: getInfographicsId } }">
            {{ $t("infographics") }}
          </router-link>
        </h2>
        <div class="infographic-devided-section">
          <p class="infographic-devided-text">{{ $t("infographicHighlightShortText") }}</p>
          <router-link :to="{ name: $t('infographicsRouteName'), params: { id: getInfographicsId } }" tag="a"
            class="infographic-devided-button"> {{ $t("more") }}</router-link>
        </div>
      </div>
      <div class="infographic-image">
        <router-link :to="{ name: 'news-content', params: { id: item.id } }" tag="a"><img :src="item.url"
            alt="Hero illustration" loading="lazy"></router-link>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      // item: null
    }
  },
  computed: {
    ...mapGetters(["getHighlightedInfographicsNew", "getOneHighlightedInfographics"]),
    getInfographicsId() {
      return this.getHighlightedInfographicsNew.length > 0
        ? this.getHighlightedInfographicsNew[0].parentId
        : 0;
    },
    item() {
      return this.getOneHighlightedInfographics || null;
    }
  },
  methods: {
    ...mapActions(["fetchContentById"]),
  },
}
</script>


<style scoped>
.infographic {
  padding: 20px 7%;
  display: flex;
  align-items: stretch;
  width: 100%;
  background-color: var(--secondary-color);
}

.infographic-container {
  width: 100%;
  display: flex;
  gap: 10px;
  align-items: stretch;
}

.infographic-content {
  width: 65%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.infographic-title {
  color: var(--main-color);
  font-size: 30px;
  margin-bottom: 10px;
  font-weight: 600;
  cursor: pointer;
  padding-left: 3px;
}

.infographic-title a,
.infographic-title router-link {
  color: var(--main-color);
  text-decoration: none;
}

.highlight {
  color: var(--main-color);
  position: relative;
  display: inline-block;
}

.highlight::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: var(--main-color);
  transform: scaleX(0);
  transform-origin: right;
  transition: transform 0.3s ease;
}

.infographic-content:hover .highlight::after {
  transform: scaleX(1);
  transform-origin: left;
}

.infographic-devided-section {
  background: var(--light-color);
  backdrop-filter: blur(8px);
  border-radius: 1rem;
  padding: 2rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  width: 95%;
  margin-top: auto;
}

.infographic-devided-text {
  font-size: 20px;
  line-height: 1.2;
  font-weight: 500;
  color: #465481;
  margin-bottom: 2rem;
}

.infographic-devided-button {
  display: inline-block;
  background-color: transparent;
  color: var(--main-color);
  border: 1px solid var(--main-color);
  padding: 10px;
  border-radius: 0.5rem;
  font-size: 18px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  text-align: center;
  width: 35%;
  min-width: 150px;
  max-width: 250px;
}

.infographic-devided-button:hover {
  background-color: var(--main-color);
  color: #fff;
  transition: color 0.3s ease, background-color 0.3s ease;
}

.infographic-devided-section:hover a {
  text-decoration: underline;
  text-decoration-color: #fff;
}


.infographic-image {
  width: 35%;
  max-height: 230px;
  position: relative;
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.infographic-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s ease;
}

.infographic-image:hover img {
  transform: scale(1.02);
}


@media (max-width: 1200px) {
  .infographic-title {
    font-size: 30px;
  }

  .infographic-devided-text {
    font-size: 18px;

  }

  .infographic-button {
    width: 50%;
  }
}

@media (max-width: 992px) {

  .infographic-devided-section {
    width: 100%;
    margin-top: 0;
  }

  .infographic-container {
    flex-direction: column;
    gap: 2rem;
  }

  .infographic-content,
  .infographic-image {
    width: 100%;
  }

  .infographic-content {
    justify-content: start;
    height: auto;
  }

  .infographic-title,
  .infographic-section {
    width: 100%;
  }

  .infographic-button {
    width: 40%;
  }

  .infographic-image {
    height: auto;
    max-height: unset;
  }

  .infographic-image img {
    object-fit: cover;
  }
}

@media (max-width: 768px) {
  .infographic {
    padding: 4rem 7%;
  }

  .infographic-title {
    font-size: 1.75rem;
  }

  .infographic-section {
    padding: 1.5rem;
  }

  .infographic-text {
    font-size: 18px;
  }

  .infographic-button {
    width: 50%;
  }

  .infographic-image {
    height: 300px;
    max-height: 300px;
  }

  .infographic-devided-button {
    padding: 5px;
  }

}

@media (max-width: 480px) {
  .infographic {
    padding: 3rem 7%;
  }

  .infographic-title {
    font-size: 1.5rem;
  }

  .infographic-image {
    height: 250px;
  }

  .infographic-button {
    width: 100%;
  }

  .infographic-devided-text {
    font-size: 18px;

  }

}
</style>